<template>
  <AuthWrapper>
    <div class="auth-contents">
      <a-form @finish="handleSubmit" :model="formState" layout="vertical">
        <sdHeading as="h3">Forgot Password?</sdHeading>
        <p class="forgot-text"></p>
        <a-form-item label="Email Address" name="email">
          <a-input type="email" v-model:value="formState.email" placeholder="name@example.com" />
        </a-form-item>
        <a-form-item>
          <sdButton class="btn-reset" htmlType="submit" type="primary" size="large"> Send Reset Instructions </sdButton>
        </a-form-item>
        <p class="return-text">Return to <router-link to="/auth/login">Sign In</router-link></p>
      </a-form>
    </div>
  </AuthWrapper>
</template>
<script>
import { reactive } from 'vue';
import { AuthWrapper } from './style';
import { DataService } from '@/config/dataService/dataService';
import { Notification } from 'ant-design-vue';
import { useRouter } from 'vue-router';

const ForgotPassword = {
  name: 'ForgotPassword',
  components: { AuthWrapper },
  setup() {
    const { push } = useRouter();

    const handleSubmit = async () => {
      const {
        data: { status },
      } = await DataService.post(`auth/forgot-password`, formState);

      if (status === 'success') {
        Notification['success']({
          message: 'You’ll receive an email with your password reset.',
          duration: 10,
        });
        push({ name: 'login' });
      }
    };

    const formState = reactive({
      email: '',
    });

    return {
      handleSubmit,
      formState,
    };
  },
};

export default ForgotPassword;
</script>
